export const AI_JOB_STATUS = {
	QUEUED: 'queued',
	PROCESSING: 'processing',
	COMPLETED: 'completed',
	FAILED: 'failed',
}

export const AI_PROCESSING_STATUS = {
	IDLE: 'idle',
	POLLING: 'polling',
	QUEUED: 'queued',
	PROCESSING: 'processing',
	COMPLETED: 'completed',
	FAILED: 'failed',
}

export const AI_JOB_OPERATION = {
	INITIAL_GENERATION: 'initial_generation',
}
